<template>
  <head>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
    <meta name="viewport" content="width=device-width, initial-scale=1.0"> 
  </head>

  <section class="relative">
    <img src="/image/im13.jpg" alt="Contact Us" class="w-full h-[300px] sm:h-[400px] md:h-[550px] object-cover">
    <div class="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center flex-col px-4">
      <img src="/image/im8.png" alt="Logo HotelBook" class="h-24 w-24 sm:h-32 sm:w-32 md:h-40 md:w-40">
      <h1 class="text-white italic text-xl sm:text-2xl font-serif">UA Univeristy</h1>
      <h1 class="text-white italic text-base sm:text-xl font-serif">Depuis 1988</h1>
      <h1 class="text-white text-2xl sm:text-3xl md:text-5xl text-center font-serif mt-2">Bienvenue sur StudentGate</h1>
    </div>
  </section>

  <section class="text-center py-8 sm:py-12 md:py-16 bg-gray-100 px-4">
    <p class="mt-4 mb-2 text-black-600 text-sm sm:text-base md:text-lg font-serif max-w-2xl mx-auto">
      StudentGate est accessible uniquement par les etudiants de l'UA University et offre un accès centralisé à différents services de l'Université tels que les sites de cours et une consultation sécurisée aux informations personnelles.
    </p>
    <button
      @click="goToStudentGate"
      class="mt-6 sm:mt-8 bg-blue-900 text-white px-4 py-2 rounded-lg text-sm sm:text-base md:text-lg hover:bg-blue-800 font-serif">
      Accéder à StudentGate
    </button>
  </section>

  <section class="py-8 sm:py-12 bg-white px-4">
    <div class="container mx-auto">
      <h2 class="text-2xl sm:text-3xl font-bold text-center text-blue-900 mb-8 sm:mb-12 font-serif">Nos Services</h2>
      
      <div class="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 lg:gap-12">
        <div class="flex flex-col items-center w-1/2 sm:w-1/3 md:w-1/4 px-2">
          <div class="rounded-full overflow-hidden w-20 h-20 sm:w-28 sm:h-28 md:w-40 md:h-40 lg:w-60 lg:h-60 border-2 border-grey-900 mb-2 sm:mb-4">
            <img src="/image/im26.png" alt="Service 1" class="w-full h-full object-cover">
          </div>
          <h3 class="text-sm sm:text-base md:text-lg text-center font-serif">Un accès centralisé</h3>
        </div>
        
        <div class="flex flex-col items-center w-1/2 sm:w-1/3 md:w-1/4 px-2">
          <div class="rounded-full overflow-hidden w-20 h-20 sm:w-28 sm:h-28 md:w-40 md:h-40 lg:w-60 lg:h-60 border-2 border-grey-900 mb-2 sm:mb-4">
           <img src="/image/im14.png" alt="Logo HotelBook" class="w-full h-full object-cover">
          </div>
          <h3 class="text-sm sm:text-base md:text-lg text-center font-serif">Vos cours à porté de main</h3>
        </div>

        <div class="flex flex-col items-center w-full sm:w-1/3 md:w-1/4 px-2 mt-4 sm:mt-0">
          <div class="rounded-full overflow-hidden w-20 h-20 sm:w-28 sm:h-28 md:w-40 md:h-40 lg:w-60 lg:h-60 border-2 border-grey-900 mb-2 sm:mb-4">
            <img src="/image/im23.png" alt="Service 1" class="w-full h-full object-cover">
          </div>
          <h3 class="text-sm sm:text-base md:text-lg text-center font-serif">Consultez vos résultats à distance</h3>
        </div>
      </div>
    </div>
  </section>

  <section class="py-8 sm:py-12 bg-white px-4">
    <div class="container mx-auto">
      <h2 class="text-2xl sm:text-3xl font-bold text-center text-blue-900 mb-8 sm:mb-12 font-serif">Bientot disponible</h2>
      
      <div class="flex justify-center">
        <div class="flex flex-col items-center w-full sm:w-1/2 md:w-1/4 px-2">
          <div class="rounded-full overflow-hidden w-20 h-20 sm:w-28 sm:h-28 md:w-40 md:h-40 lg:w-60 lg:h-60 border-2 border-grey-900 mb-2 sm:mb-4">
            <img src="/image/im31.jpg" alt="Service 3" class="w-full h-full object-cover">
          </div>
          <h3 class="text-sm sm:text-base md:text-lg text-center font-serif">StudentGate disponible sur mobile</h3>
        </div>
      </div>
    </div>
  </section>

  <footer class="footer-container text-white py-8 sm:py-10 font-serif px-4">
    <div class="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 md:gap-12">
      <div class="flex flex-col items-center text-center">
        <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 sm:h-20 sm:w-20 mx-auto">
        <h2 class="text-xl sm:text-2xl font-serif font-bold mb-2 sm:mb-4">UA University</h2>
        <p class="text-xs sm:text-sm text-gray-300">
          Établissement d'enseignement supérieur technique privé depuis 1988
        </p>
      </div>

      <div class="flex flex-col items-center text-center">
        <h3 class="text-base sm:text-lg font-semibold mb-2">Liens utiles</h3>
        <ul class="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-400">
          <li><a href="#" class="hover:text-white transition">uainscription.ua</a></li>
          <li><a href="#" class="hover:text-white transition">uacomptabilite.ua</a></li>
          <li><a href="#" class="hover:text-white transition">uainfo.ua</a></li>
        </ul>
                  <router-link to="/admin" class="text-xs sm:text-sm text-gray-400 hover:text-white mt-2 text-1xl transition duration-300">adminGate.ua  </router-link>

      </div>

      <div class="flex flex-col items-center text-center">
        <h3 class="text-base sm:text-lg font-semibold mb-2 sm:mb-3">Contact</h3>
        <p class="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">📍 UA, UA City</p>
        <p class="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">📞 +001 00000000</p>
        <p class="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">📧 university@gmail.ua</p>
      </div>

      <div class="flex flex-col items-center text-center">
        <h3 class="text-base sm:text-lg font-semibold mb-2 sm:mb-3">Suivez-nous</h3>
        <div class="flex space-x-3 sm:space-x-4 text-gray-400 text-xl">
          <a href="#" class="hover:text-white transition"><img src="/image/face.png" alt="Facebook" class="h-6 w-6 sm:h-8 sm:w-8"></a>
          <a href="#" class="hover:text-white transition"><img src="/image/tik.png" alt="TikTok" class="h-6 w-6 sm:h-8 sm:w-8"></a>
          <a href="#" class="hover:text-white transition"><img src="/image/insta.png" alt="Instagram" class="h-6 w-6 sm:h-8 sm:w-8"></a>
        </div>
      </div>
    </div>

    <div class="mt-4 sm:mt-6 text-center text-xs sm:text-sm text-gray-500 border-t border-gray-800 pt-3">
      &copy; 2025 UA University. Tous droits réservés.
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    goToStudentGate() {
      this.$router.push('/Login') 
    }
  }
}
</script>

<style scoped>
.footer-container {
  background-color: #051831;
}
</style>